// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationDealsPath = 'M73.7 6.45a16.67 16.67 0 0125.138 14.456l-.006.363-6.998-.193a9.67 9.67 0 00-9.186-9.924l6.525 27.482a10.498 10.498 0 01-1.962 8.997L66.533 73.837 48.365 96.923 1.35 59.782l38.853-49.294c1.987-2.525 5.022-4 8.24-4.005h25.203l.055-.033zm-8.196 14.82a16.656 16.656 0 011.69-7.788H48.449a3.501 3.501 0 00-2.746 1.337L11.175 58.623l36.026 28.46 13.834-17.578 20.683-26.213a3.51 3.51 0 00.65-3.02l-6.362-26.79h-.148a9.671 9.671 0 00-3.36 7.275l.005.43c-.002.522.04 1.043.128 1.557l.074.385-6.844 1.468a16.086 16.086 0 01-.352-2.943l-.005-.385zm-3.526 17.708l-4.95-4.95-21 21 4.95 4.95 21-21zm-15.975.525a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm10.5 19.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z';
var IllustrationDeals = baseIllustration('IllustrationDeals', {
  getPath: () => IllustrationDealsPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationDeals;
//# sourceMappingURL=index.js.map